module.exports = __webpack_public_path__ + "static/img/MoscowAlexandr.cca2d4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/MoscowAlexandr.jpg
// module id = aKQ1
// module chunks = 0